const SITE_URL = "https://reloadpi.com";

export const CATEGORY_LABELS = {
  faq: "FAQ",
  support: "Support",
  announcements: "Announcements",
  fun: "Fun",
  "e-books": "E-BOOKS",
};

function cap(s = "") {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function toAbsoluteUrl(href) {
  if (!href) return undefined;
  if (href.startsWith("http://") || href.startsWith("https://")) return href;
  return `${SITE_URL}${href.startsWith("/") ? href : `/${href}`}`;
}

export function breadcrumbsToJsonLd(items) {
  const itemListElement = items.map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: c.label,
    ...(c.href ? { item: toAbsoluteUrl(c.href) } : {}),
  }));

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement,
  };
}

export function buildCommunityBreadcrumbs({ category, thread } = {}) {
  const crumbs = [
    { label: "Home", href: "/" },
    { label: "Community", href: "/community" },
  ];

  if (category) {
    const label = CATEGORY_LABELS[category] || cap(category);
    crumbs.push({ label, href: `/community/category/${category}` });
  }

  if (thread) {
    const href = `/community/thread/${thread._id}/${thread.slug}`;
    const max = 60;
    const label =
      thread.title.length > max
        ? thread.title.slice(0, max - 1) + "…"
        : thread.title;
    crumbs.push({ label, href });
  }

  return crumbs;
}
